


function buildDateValidator(validatorName, defaultOffset, check) {

    return /* @ngInject */ function(moment) {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {
                var units = attrs.units || 'days',
                    threshold;

                scope.$watch(attrs[validatorName], function(value) {
                    if (angular.isDefined(value) && !moment.isMoment(value)) {
                        value = moment(value);
                    }
                    threshold = value;
                    ngModel.$validate();
                });

                ngModel.$validators[validatorName] = function(modelValue, viewValue) {
                    var value = modelValue || viewValue,
                        offset = defaultOffset,
                        offsetThreshold;

                    if (angular.isDefined(attrs[validatorName + "Offset"])) {
                        offset = scope.$eval(attrs[validatorName + "Offset"]);
                    }

                    if (moment.isMoment(value) && moment.isMoment(threshold) &&
                            value.isValid() && threshold.isValid()) {
                        offsetThreshold = moment(threshold).add(offset, units);
                        console.log(ngModel.$name, offsetThreshold.format('L'), value.format('L'));
                        return check(offsetThreshold, value);
                    }
                    return true;
                };
            }
        };
    };
}

module.directive('dateMin', buildDateValidator('dateMin', 1,
    function(threshold, value) {
        return threshold.isSame(value, 'day') || threshold.isBefore(value, 'day');
    }));

module.directive('dateMax', buildDateValidator('dateMax', 0,
    function(threshold, value) {
        return threshold.isSame(value, 'day') || threshold.isAfter(value, 'day');
    }));
